export const STORE_PROFILE = {
    IMAGE_UPLOAD_ERROR:' Error uploading image. Please try again.',
    GENERAL_ERROR:'An error occured while uploading the image. try again',
}
export const SHOPIFY_DETAILS ={
    FILE_UPLOAD_ERROR:' Error uploading files.'
}

export const HOST_REWARD_TYPES = {
  CASH: { LABEL: 'Cash', VALUE: 'cash' },
  STORE_CREDIT: { LABEL: 'Store Credit', VALUE: 'store_credit' },
  GIFT_CARD: { LABEL: 'Gift Card', VALUE: 'gift_card' }
};

export const normalizeRewardType = (value) => {
  if (!value || typeof value !== 'string') {
    return HOST_REWARD_TYPES.CASH.VALUE;
  }
  const formatted = value.toLowerCase().replace(/\s+/g, "_");
  if (formatted === HOST_REWARD_TYPES.STORE_CREDIT.VALUE) {
    return HOST_REWARD_TYPES.STORE_CREDIT.VALUE;
  }
  if (formatted === HOST_REWARD_TYPES.GIFT_CARD.VALUE) {
    return HOST_REWARD_TYPES.GIFT_CARD.VALUE;
  }
  return HOST_REWARD_TYPES.CASH.VALUE;
};

/**
 * Gets the display label for a reward type value.
 * Normalizes the input value and returns the corresponding label.
 *
 * @param {string|null|undefined} rewardType - The reward type value (e.g., "cash", "store_credit", "gift_card")
 * @returns {string} The display label for the reward type ("Cash", "Store Credit", or "Gift Card")
 * @example
 * getRewardTypeLabel('store_credit') // returns 'Store Credit'
 * getRewardTypeLabel('gift_card') // returns 'Gift Card'
 * getRewardTypeLabel('cash') // returns 'Cash'
 * getRewardTypeLabel('unknown') // returns 'Cash' (default)
 * getRewardTypeLabel(null) // returns 'Cash' (default)
 */
export const getRewardTypeLabel = rewardType => {
  const normalized = normalizeRewardType(rewardType);
  if (normalized === HOST_REWARD_TYPES.STORE_CREDIT.VALUE) {
    return HOST_REWARD_TYPES.STORE_CREDIT.LABEL;
  }
  if (normalized === HOST_REWARD_TYPES.GIFT_CARD.VALUE) {
    return HOST_REWARD_TYPES.GIFT_CARD.LABEL;
  }
  return HOST_REWARD_TYPES.CASH.LABEL;
};
